/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: Type
 * root Object
 * @constructor
 */
window.Type = function() {};
$hxClasses['Type'] = Type;
/** @private @type {Array} */
Type.__name__ = ["Type"];

/**
 * getClass
 *
 * $type TFun([{ name => o, t => TInst(getClass.T,[]), opt => false }],TInst(Class,[TInst(getClass.T,[])]))
 * @public
 * @static
 * @param {getClass.T}  o 
 * @return {Class}
 */
Type.getClass = function(o) {
	if(o == null) return null;
	return o.__class__;
};


/**
 * getEnum
 *
 * $type TFun([{ name => o, t => TInst(EnumValue,[]), opt => false }],TInst(Enum,[TDynamic(null)]))
 * @public
 * @static
 * @param {EnumValue}  o 
 * @return {Enum}
 */
Type.getEnum = function(o) {
	if(o == null) return null;
	return o.__enum__;
};


/**
 * getSuperClass
 *
 * $type TFun([{ name => c, t => TInst(Class,[TDynamic(null)]), opt => false }],TInst(Class,[TDynamic(null)]))
 * @public
 * @static
 * @param {Class}  c 
 * @return {Class}
 */
Type.getSuperClass = function(c) {
	return c.__super__;
};


/**
 * getClassName
 *
 * $type TFun([{ name => c, t => TInst(Class,[TDynamic(null)]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {Class}  c 
 * @return {string}
 */
Type.getClassName = function(c) {
	/** @type {Array} */ 
	var a = c.__name__;
	return a.join(".");
};


/**
 * getEnumName
 *
 * $type TFun([{ name => e, t => TInst(Enum,[TDynamic(null)]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {Enum}  e 
 * @return {string}
 */
Type.getEnumName = function(e) {
	/** @type {Array} */
	var a = e.__ename__;
	return a.join(".");
};


/**
 * resolveClass
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TInst(Class,[TDynamic(null)]))
 * @public
 * @static
 * @param {string}  name 
 * @return {Class}
 */
Type.resolveClass = function(name) {
	var /** @type {Class} */ cl = $hxClasses[name];
	/*  ensure that this is a class */
	if(cl == null || !cl.__name__) return null;
	return cl;
};


/**
 * resolveEnum
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TInst(Enum,[TDynamic(null)]))
 * @public
 * @static
 * @param {string}  name 
 * @return {Enum}
 */
Type.resolveEnum = function(name) {
	var /** @type {*} */ e = $hxClasses[name];
	/*  ensure that this is an enum */
	if(e == null || !e.__ename__) return null;
	return e;
};


/**
 * createInstance
 *
 * $type TFun([{ name => cl, t => TInst(Class,[TInst(createInstance.T,[])]), opt => false },{ name => args, t => TInst(Array,[TDynamic(null)]), opt => false }],TInst(createInstance.T,[]))
 * @public
 * @static
 * @param {Class}  cl 
 * @param {Array}  args 
 * @return {createInstance.T}
 */
Type.createInstance = function(cl,args) {
	switch(args.length) {
		case 0:
			return new cl();
		case 1:
			return new cl(args[0]);
		case 2:
			return new cl(args[0],args[1]);
		case 3:
			return new cl(args[0],args[1],args[2]);
		case 4:
			return new cl(args[0],args[1],args[2],args[3]);
		case 5:
			return new cl(args[0],args[1],args[2],args[3],args[4]);
		case 6:
			return new cl(args[0],args[1],args[2],args[3],args[4],args[5]);
		case 7:
			return new cl(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);
		case 8:
			return new cl(args[0],args[1],args[2],args[3],args[4],args[5],args[6],args[7]);
		default:
			throw "Too many arguments";
	}
};


/**
 * createEmptyInstance
 *
 * $type TFun([{ name => cl, t => TInst(Class,[TInst(createEmptyInstance.T,[])]), opt => false }],TInst(createEmptyInstance.T,[]))
 * @public
 * @static
 * @param {Class}  cl 
 * @return {createEmptyInstance.T}
 */
Type.createEmptyInstance = function(cl) {
	function empty() {}; empty.prototype = cl.prototype;
	return new empty();
};


/**
 * createEnum
 *
 * $type TFun([{ name => e, t => TInst(Enum,[TInst(createEnum.T,[])]), opt => false },{ name => constr, t => TInst(String,[]), opt => false },{ name => params, t => TInst(Array,[TDynamic(null)]), opt => true }],TInst(createEnum.T,[]))
 * @public
 * @static
 * @param {Enum}  e 
 * @param {string}  constr 
 * @param {Array}  params 
 * @return {createEnum.T}
 */
Type.createEnum = function(e,constr,params) {
	var /** @type {createEnum.T} */ f = Reflect.field(e,constr);
	if(f == null) throw "No such constructor " + constr;
	if(Reflect.isFunction(f)) {
		if(params == null) throw "Constructor " + constr + " need parameters";
		return f.apply(e,params);
	}
	if(params != null && params.length != 0) throw "Constructor " + constr + " does not need parameters";
	return f;
};


/**
 * createEnumIndex
 *
 * $type TFun([{ name => e, t => TInst(Enum,[TInst(createEnumIndex.T,[])]), opt => false },{ name => index, t => TInst(Int,[]), opt => false },{ name => params, t => TInst(Array,[TDynamic(null)]), opt => true }],TInst(createEnumIndex.T,[]))
 * @public
 * @static
 * @param {Enum}  e 
 * @param {number}  index 
 * @param {Array}  params 
 * @return {createEnumIndex.T}
 */
Type.createEnumIndex = function(e,index,params) {
	var /** @type {string} */ c = e.__constructs__[index];
	if(c == null) throw index + " is not a valid enum constructor index";
	return Type.createEnum(e,c,params);
};


/**
 * getInstanceFields
 *
 * $type TFun([{ name => c, t => TInst(Class,[TDynamic(null)]), opt => false }],TInst(Array,[TInst(String,[])]))
 * @public
 * @static
 * @param {Class}  c 
 * @return {Array}
 */
Type.getInstanceFields = function(c) {
	var /** @type {Array} */ a = [];
	for(var i in c.prototype) a.push(i);
	HxOverrides.remove(a,"__class__");
	HxOverrides.remove(a,"__properties__");
	return a;
};


/**
 * getClassFields
 *
 * $type TFun([{ name => c, t => TInst(Class,[TDynamic(null)]), opt => false }],TInst(Array,[TInst(String,[])]))
 * @public
 * @static
 * @param {Class}  c 
 * @return {Array}
 */
Type.getClassFields = function(c) {
	var /** @type {Array} */ a = Reflect.fields(c);
	HxOverrides.remove(a,"__name__");
	HxOverrides.remove(a,"__interfaces__");
	HxOverrides.remove(a,"__properties__");
	HxOverrides.remove(a,"__super__");
	HxOverrides.remove(a,"prototype");
	return a;
};


/**
 * getEnumConstructs
 *
 * $type TFun([{ name => e, t => TInst(Enum,[TDynamic(null)]), opt => false }],TInst(Array,[TInst(String,[])]))
 * @public
 * @static
 * @param {Enum}  e 
 * @return {Array}
 */
Type.getEnumConstructs = function(e) {
	var /** @type {Array} */ a = e.__constructs__;
	return a.slice();
};


/**
 * typeof
 *
 * $type TFun([{ name => v, t => TDynamic(null), opt => false }],TEnum(ValueType,[]))
 * @public
 * @static
 * @param {null}  v 
 * @return {ValueType}
 */
Type["typeof"] = function(v) {
	switch(typeof(v)) {
		case "boolean":
			return ValueType.TBool;
		case "string":
			return ValueType.TClass(String);
		case "number":
			/*  this should handle all cases : NaN, +/-Inf and Floats outside range */
			if(Math.ceil(v) == v % 2147483648.0) return ValueType.TInt;
			return ValueType.TFloat;
		case "object":
			if(v == null) return ValueType.TNull;
			var /** @type {Enum} */ e = v.__enum__;
			if(e != null) return ValueType.TEnum(e);
			var /** @type {Class} */ c = v.__class__;
			if(c != null) return ValueType.TClass(c);
			return ValueType.TObject;
		case "function":
			if(v.__name__ || v.__ename__) return ValueType.TObject;
			return ValueType.TFunction;
		case "undefined":
			return ValueType.TNull;
		default:
			return ValueType.TUnknown;
	}
};


/**
 * enumEq
 *
 * $type TFun([{ name => a, t => TInst(enumEq.T,[]), opt => false },{ name => b, t => TInst(enumEq.T,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @static
 * @param {enumEq.T}  a 
 * @param {enumEq.T}  b 
 * @return {boolean}
 */
Type.enumEq = function(a,b) {
	if(a == b) return true;
	try {
		if(a[0] != b[0]) return false;
		var /** @type {number} */ _g1 = 2, /** @type {number} */ _g = a.length;
		while(_g1 < _g) {
			var /** @type {number} */ i = _g1++;
			if(!Type.enumEq(a[i],b[i])) return false;
		}
		var /** TODO: define type */ e = a.__enum__;
		if(e != b.__enum__ || e == null) return false;
	} catch( e ) {
		return false;
	}
	return true;
};


/**
 * enumConstructor
 *
 * $type TFun([{ name => e, t => TInst(EnumValue,[]), opt => false }],TInst(String,[]))
 * @public
 * @static
 * @param {EnumValue}  e 
 * @return {string}
 */
Type.enumConstructor = function(e) {
	return e[0];
};


/**
 * enumParameters
 *
 * $type TFun([{ name => e, t => TInst(EnumValue,[]), opt => false }],TInst(Array,[TDynamic(null)]))
 * @public
 * @static
 * @param {EnumValue}  e 
 * @return {Array}
 */
Type.enumParameters = function(e) {
	return e.slice(2);
};


/**
 * enumIndex
 *
 * $type TFun([{ name => e, t => TInst(EnumValue,[]), opt => false }],TInst(Int,[]))
 * @public
 * @static
 * @param {EnumValue}  e 
 * @return {number}
 */
Type.enumIndex = function(e) {
	return e[1];
};


/**
 * allEnums
 *
 * $type TFun([{ name => e, t => TInst(Enum,[TInst(allEnums.T,[])]), opt => false }],TInst(Array,[TInst(allEnums.T,[])]))
 * @public
 * @static
 * @param {Enum}  e 
 * @return {Array}
 */
Type.allEnums = function(e) {
	var /** @type {Array} */ all = [];
	var /** @type {Array} */ cst = e.__constructs__;
	var /** @type {number} */ _g = 0;
	while(_g < cst.length) {
		var /** @type {string} */ c = cst[_g];
		++_g;
		var /** @type {allEnums.T} */ v = Reflect.field(e,c);
		if(!Reflect.isFunction(v)) all.push(v);
	}
	return all;
};

/** @type {Type} */
Type.prototype.__class__ = Type;
